export default __webpack_public_path__ + "static/media/conexion-white.9e2555c2.png";